import React, { Component } from 'react'
import ReactQuill, { Quill } from 'react-quill'
import 'react-quill/dist/quill.snow.css'
import 'react-quill/dist/quill.core.css'
import QuillEditor from './editor.style'
import { baseUrlPhotoCloud } from '../../../services/apis/createAPIServices'
export default class Editor extends React.Component {
    constructor(props) {
        super(props)
        this.handleChange = this.handleChange.bind(this)
        this.state = { value: '' }
        this.reactQuillRef = null
        this.quillModules = {
            toolbar: {
                handlers: {
                    image: this.imageHandler,
                },
                container: [
                    ['bold', 'italic', 'underline', 'strike'], // toggled buttons
                    ['blockquote', 'code-block'],

                    [{ header: 1 }, { header: 2 }], // custom button values
                    [{ list: 'ordered' }, { list: 'bullet' }],
                    [{ script: 'sub' }, { script: 'super' }], // superscript/subscript
                    [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
                    [{ direction: 'rtl' }], // text direction

                    [{ size: ['small', false, 'large', 'huge'] }], // custom dropdown

                    [{ color: [] }, { background: [] }], // dropdown with defaults from theme
                    ['image'],
                    [{ font: [] }],
                    [{ align: [] }],

                    ['clean'],
                ],
            },
        }

        this.formats = [
            'header',
            'font',
            'size',
            'bold',
            'italic',
            'underline',
            'strike',
            'blockquote',
            'list',
            'bullet',
            'indent',
            'link',
            'image',
            'color',
        ]
    }
    imageHandler = () => {
        const input = document.createElement('input')
        input.setAttribute('type', 'file')
        input.setAttribute('accept', 'image/*')
        input.click()
        input.onchange = async function() {
            const file = input.files[0]
            let formData = new FormData()
            formData.append('files', file, file.name)

            fetch(baseUrlPhotoCloud, {
                method: 'POST',

                body: formData,
            })
                .then(respone => respone.json())
                .then(data => {
                    // resolve(data.uploaded_files[0])
                    console.log('reactQuillRef', this.reactQuillRef)
                    const range = this.reactQuillRef.getEditorSelection()

                    this.reactQuillRef
                        .getEditor()
                        .insertEmbed(
                            range.index,
                            'image',
                            data.uploaded_files[0]
                        )
                    console.log('testdata', data.uploaded_files[0])
                })
                .catch(error => console.log(error))
        }.bind(this)
    }

    handleChange(value) {
        const { form } = this.props
        this.setState({ value })
        console.log('formmm', form)
    }

    render() {
        const options = {
            theme: 'snow',
            formats: Editor.formats,
            placeholder: 'Write Something',
            value: this.state.value,
            // onChange: this.handleChange,
            modules: this.quillModules,
            ...this.props,
        }
        return (
            <QuillEditor>
                {/* <CustomToolbar /> */}
                <ReactQuill
                    ref={el => {
                        this.reactQuillRef = el
                    }}
                    {...options}
                />
            </QuillEditor>
        )
    }
}
